import dayjs from 'dayjs';
import EvaluationTerm from './EvaluationTerm.js';
import SalaryReviewTermType from '../enums/SalaryReviewTermType.js';
import SalaryReview from './SalaryReview.js';
import SalaryReviewTermStatus from '../enums/SalaryReviewTermStatus';

export default class SalaryReviewTerm {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.evaluationTermId = data?.evaluationTermId;
    this.status = data?.status ? SalaryReviewTermStatus.of(data.status) : null;
    this.type = data?.type ? SalaryReviewTermType.of(data.type) : null;
    this.name = data?.name;
    this.cutoffDate = data?.cutoffDate ? dayjs(data.cutoffDate) : null;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.evaluationTerm = data?.evaluationTerm ? new EvaluationTerm(data?.evaluationTerm) : null;
    this.salaryReviews = data?.salaryReviews ? data.salaryReviews.map((s) => new SalaryReview(s)) : [];
  }
}
